import React from 'react';
import { Modal } from 'react-bootstrap';
import { Warning48Filled } from '@fluentui/react-icons';
import styles from './DoubleConfirmationModal.module.css';

const WarningConfirmModal = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    messages,
    cancelLabel = 'Cancel',
    confirmLabel = 'Continue',
    confirmLoading = false,
}) => {
    const paragraphs = messages?.length ? messages : message ? [message] : [];

    return (
        <Modal centered show={open} onHide={onClose} className={styles.modalMainBody}>
            <Modal.Body className={styles.confirmationModalBody}>
                <div className={styles.confirmationModalMsg}>
                    <div className="mb-4 text-center">
                        <Warning48Filled color="var(--Brand-Primary)" />
                    </div>
                    {title ? <h3 style={{ textAlign: 'center', fontSize: 20, fontWeight: 600, marginBottom: 16 }}>{title}</h3> : null}
                    {paragraphs.map((paragraph, index) => (
                        <p
                            key={index}
                            className={styles.message}
                            style={{ marginBottom: index < paragraphs.length - 1 ? 16 : 34 }}>
                            {paragraph}
                        </p>
                    ))}
                    <div className="d-flex justify-content-between align-items-center">
                        <button type="button" onClick={onClose} className={styles.secondaryBtn} disabled={confirmLoading}>
                            {cancelLabel}
                        </button>
                        <span
                            role="button"
                            onClick={() => {
                                if (!confirmLoading) onConfirm();
                            }}
                            className={styles.orangeLink}
                            style={{ opacity: confirmLoading ? 0.6 : 1, pointerEvents: confirmLoading ? 'none' : 'auto' }}>
                            {confirmLabel}
                        </span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default WarningConfirmModal;
